.container {
  height: 100%;
  display: flex;
  flex-direction: column;

  & > header {
    margin: 1.6rem 0;
  }
}
